import {useTranslation} from 'react-i18next';
import {IUser} from '../../auth/type';
import {ENV_NAME, REGION} from '../../common/constant';
import {Page} from '../../common/constant/page';
import useTypedSelector from '../../common/hook/useTypedSelector';
import useUserAgent from '../../common/hook/useUserAgent';
import {IUserAgent} from '../../common/type';
import {PageInfo, routeTo} from '../../common/util/PageRouter';
import {ISendEventParam} from '../../common/util/tracking';
import SettingItemV4 from '../../commonSub/component/SettingItemV4';
import SettingItemWrapperV4 from '../../commonSub/component/SettingItemWrapperV4';
import {getCsMailUrl} from '../../commonSub/function';
import {IArrowSettigItem} from '../../commonSub/type';
import {sendMoreEvent} from '../common';
import MoreContainerV4 from '../component/MoreContainerV4';

interface IProps {
  isWebview: boolean;
}

export default function CustomerCenter({isWebview}: IProps) {
  const {t} = useTranslation();
  const userAgent = useUserAgent();
  const user = useTypedSelector(state => state.auth.user);

  return (
    <MoreContainerV4 isWebview={isWebview}>
      <SettingItemWrapperV4>
        {CUSTOMER_CENTER_LIST.map(
          ({topText, pageInfo, actionName, onClick, ...props}, idx) => (
            <SettingItemV4
              key={idx}
              topText={t(topText)}
              onClick={() => {
                sendMoreEvent({
                  actionName,
                  page: 'sidemenu_customer_center',
                  customProps: {event_layer: 'menu'},
                });
                if (onClick) {
                  onClick({pageInfo, userAgent, user});
                } else if (pageInfo) {
                  routeTo(pageInfo);
                }
              }}
              pageInfo={pageInfo}
              {...props}
            />
          )
        )}
      </SettingItemWrapperV4>
    </MoreContainerV4>
  );
}

type ICustomerCenterSettingItem = Omit<IArrowSettigItem, 'onClick'> &
  Pick<ISendEventParam, 'actionName'> & {
    onClick?: ({
      userAgent,
      user,
    }: {
      pageInfo?: PageInfo;
      userAgent?: IUserAgent;
      user?: IUser;
    }) => void;
  };

//  focusId는 하드 코딩으로. 만약 작품 투고하기 공지사항이 바뀌면 해당 focusId로 다시 맞춰줘야한다.
const FOCUS_ID_MAP: {[key: string]: number} = {
  local: 39,
  dev: 39,
  qa: 3,
  cbt: 1,
  prod: 1,
};

const FAQ: ICustomerCenterSettingItem = {
  type: 'arrow',
  topText: 'more_help_faq',
  pageInfo: {page: Page.MoreFaq},
  actionName: 'faq',
};

const RIGHT_REPORT: ICustomerCenterSettingItem = {
  type: 'arrow',
  topText: 'more_customer_rights_report',
  pageInfo: {page: Page.MoreRightReport},
  actionName: 'customer_rights_report',
};

const INQUIRY: ICustomerCenterSettingItem = {
  type: 'arrow',
  topText: 'more_customer_title_inquiry',
  pageInfo: {page: Page.MoreInquiry},
  actionName: 'service_inquiry',
  onClick: ({pageInfo, userAgent, user}) => {
    REGION === 'kor'
      ? pageInfo
        ? routeTo(pageInfo)
        : undefined
      : location.assign(getCsMailUrl({userAgent, user}));
  },
};

const CONTENT_SUBMIT: ICustomerCenterSettingItem = {
  type: 'arrow',
  topText: 'more_customer_submit',
  pageInfo: {
    page: Page.MoreNotice,
    focusId: FOCUS_ID_MAP[ENV_NAME],
  },
  actionName: 'submit',
};

const BUSINESS_PARTNERSHIP: ICustomerCenterSettingItem = {
  type: 'arrow',
  topText: 'more_customer_inquiry_business',
  actionName: 'business',
  onClick: ({userAgent, user}) => {
    location.assign(
      getCsMailUrl({userAgent, user, email: 'webtoon_biz@kakaoent.com'})
    );
  },
};

const SERVICE_INFORMATION: ICustomerCenterSettingItem = {
  type: 'arrow',
  topText: 'more_serviceinfo',
  pageInfo: {page: Page.MoreServiceInformation},
  actionName: 'service_info',
};

const CUSTOMER_CENTER_LIST =
  REGION === 'kor'
    ? [
        FAQ,
        RIGHT_REPORT,
        INQUIRY,
        CONTENT_SUBMIT,
        BUSINESS_PARTNERSHIP,
        SERVICE_INFORMATION,
      ]
    : [FAQ, INQUIRY, SERVICE_INFORMATION];
